module.exports = __webpack_public_path__ + "img/laka_antysmogowa_01.e49de017.jpg";